import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSliderText, clearSliderTextState } from "../../redux/Slices/SliderTextSlice";
import { validateFieldLanguage } from "../../Utils/languageValidation";
import { toast } from "react-toastify";

const AddSliderText = ({ onSuccess }) => {
  const dispatch = useDispatch();

  const { addLoading, addError, addSuccessMessage } = useSelector((state) => state.sliderTexts);

  const [formData, setFormData] = useState({
    text_ar: "",
    text_en: "",
    status: 1,
  });

  useEffect(() => {
    dispatch(clearSliderTextState());
  }, [dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // BUG-24 fix: التحقق من لغة الحقول
    const arError = validateFieldLanguage(formData.text_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.text_en, "en");
    if (enError) return toast.error(enError);

    const submitData = {
      ...formData,
      status: parseInt(formData.status)
    };
    dispatch(addSliderText(submitData));
  };

  useEffect(() => {
    if (addSuccessMessage) {
      toast.success(addSuccessMessage);
      setFormData({
        text_ar: "",
        text_en: "",
        status: 1,
      });
      if (onSuccess) onSuccess();
    }
    if (addError) {
      toast.error(addError);
    }
  }, [addSuccessMessage, addError, onSuccess]);

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div style={{ direction: "rtl" }}>
      <style>{`
        .slide-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .slide-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>النص (العربية) *</label>
            <textarea
              style={inputStyle}
              name="text_ar"
              value={formData.text_ar}
              onChange={handleChange}
              onFocus={focusHandler}
              onBlur={blurHandler}
              rows="3"
              placeholder="مثال: خصم 20% على كتب المراجعة النهائية..."
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>النص (الإنجليزية) *</label>
            <textarea
              style={inputStyle}
              name="text_en"
              value={formData.text_en}
              onChange={handleChange}
              onFocus={focusHandler}
              onBlur={blurHandler}
              rows="3"
              placeholder="Example: 20% off on all revision books..."
              required
            />
          </div>
          <div className="col-md-12 mb-3">
            <label style={labelStyle}>الحالة *</label>
            <select
              className="slide-custom-select"
              name="status"
              value={formData.status}
              onChange={handleChange}
              required
            >
              <option value={1}>نشط (يتم عرضه بالبانر)</option>
              <option value={0}>غير نشط</option>
            </select>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f1f5f9", marginTop: 15, paddingTop: 15 }}>
          <button type="button" onClick={onSuccess} style={{ padding: "8px 20px", borderRadius: 9, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>إلغاء</button>
          <button type="submit" disabled={addLoading} style={{ padding: "8px 26px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,var(--main-color),var(--main-light))", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>
            {addLoading ? 'جاري الحفظ...' : 'إضافة النص'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSliderText;